<form nz-form nzLayout="vertical" [formGroup]="form">
  <div nz-row [nzGutter]="14">
    <div nz-col [nzSpan]="24">
      @if (spec) {
        <beautyapp-input
          label="{{ 'calendar.form.specialProcedure' | translate }}"
          [ngModel]="spec?.serviceName"
          [ngModelOptions]="{ standalone: true }"
          [readonly]="true"
        ></beautyapp-input>
      } @else {
        <beautyapp-select
          formControlName="serviceId"
          [data]="services"
          label="{{ 'calendar.form.specialProcedure' | translate }}"
          placeholder="{{ 'calendar.form.specialProcedure' | translate }}"
          valueMember="id"
          displayMember="name"
          (selected)="selectService($event)"
        ></beautyapp-select>
      }
    </div>

    <div nz-col [nzSpan]="12">
      <beautyapp-select
        formControlName="employeeId"
        [data]="employees"
        label="{{ 'calendar.form.specialist' | translate }}"
        placeholder="{{ 'calendar.form.specialist' | translate }}"
        valueMember="id"
        displayMember="fullName"
        (selected)="selectEmployee($event)"
      ></beautyapp-select>
    </div>

    <div nz-col [nzSpan]="12">
      <beautyapp-input
        label="{{ 'calendar.form.price' | translate }}"
        placeholder="{{ 'calendar.form.gel' | translate }}"
        type="number"
        prefixIcon="dollar"
        formControlName="price"
      ></beautyapp-input>
    </div>

    <div nz-col [nzSpan]="12">
      <beautyapp-input
        label="{{ 'calendar.form.fixatedSalary' | translate }}"
        placeholder="{{ 'calendar.form.fixatedSalary' | translate }}"
        type="number"
        prefixIcon="dollar"
        formControlName="salaryFixed"
      ></beautyapp-input>
    </div>

    <div nz-col [nzSpan]="12">
      <beautyapp-input
        label="{{ 'calendar.form.salary%' | translate }}"
        placeholder="{{ 'calendar.form.salary%' | translate }}"
        type="number"
        prefixIcon="percentage"
        formControlName="salaryPercent"
        [min]="0"
        [max]="100"
        [errors]="{ min: 'validators.percentRange', max: 'validators.percentRange' }"
      ></beautyapp-input>
    </div>
  </div>
</form>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modal.close()">
    {{ 'buttons.close' | translate }}
  </button>
  <button nz-button nzType="primary" (click)="submit()" [disabled]="form.invalid">
    {{ 'buttons.save' | translate }}
  </button>
</div>
